import { initTracing } from 'libs/browser-tracing'

initTracing()
